<template>
  <section class="overview-section">
    <div class="container">
      <!-- Header -->
      <div class="ov-header">
        <span class="ov-badge">পরিসংখ্যান</span>
        <h2 class="wow fadeInUp" data-wow-delay=".2s">এক নজরে বিসিএস প্রস্তুতি</h2>
        <p class="wow fadeInUp" data-wow-delay=".3s">
          <span class="ov-highlight">৯ লাখ+</span> চাকরী প্রত্যাশী বিশ্বাস রেখেছে বিসিএস প্রস্তুতির উপর
        </p>
      </div>

      <!-- Stats Grid -->
      <div class="ov-grid">
        <div class="ov-card wow fadeInUp" data-wow-delay=".1s" style="--accent:#0095FF; --accent-bg:#EAF4FF;">
          <div class="ov-card-icon">🎓</div>
          <div class="ov-card-num">২০+</div>
          <div class="ov-card-label">লাইভ কোর্স</div>
        </div>

        <div class="ov-card wow fadeInUp" data-wow-delay=".2s" style="--accent:#2563EB; --accent-bg:#EAEEFF;">
          <div class="ov-card-icon">📝</div>
          <div class="ov-card-num">১ লক্ষ+</div>
          <div class="ov-card-label">ব্যাখ্যাসহ প্রশ্ন</div>
        </div>

        <div class="ov-card wow fadeInUp" data-wow-delay=".3s" style="--accent:#0EA5E9; --accent-bg:#E6F6FE;">
          <div class="ov-card-icon">📚</div>
          <div class="ov-card-num">৩০০+</div>
          <div class="ov-card-label">টপিক</div>
        </div>

        <div class="ov-card wow fadeInUp" data-wow-delay=".4s" style="--accent:#1D4ED8; --accent-bg:#E8ECFB;">
          <div class="ov-card-icon">⬇️</div>
          <div class="ov-card-num">৯ লাখ+</div>
          <div class="ov-card-label">ডাউনলোড</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.overview-section {
  background: #ffffff;
  padding: 80px 0 88px;
}

.container {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header */
.ov-header {
  text-align: center;
  margin-bottom: 52px;
}
.ov-badge {
  display: inline-block;
  font-size: 0.7rem; font-weight: 700;
  letter-spacing: 0.08em; text-transform: uppercase;
  color: #0066CC;
  background: rgba(0,149,255,0.12);
  border: 1px solid rgba(0,149,255,0.28);
  padding: 4px 14px; border-radius: 50px;
  margin-bottom: 16px;
}
.ov-header h2 {
  font-size: clamp(1.5rem, 3.5vw, 2.2rem);
  font-weight: 800;
  color: #191b47;
  margin-bottom: 12px;
  line-height: 1.3;
}
.ov-header p {
  font-size: 1rem;
  color: #64748b;
  margin: 0;
}
.ov-highlight {
  color: #0095FF;
  font-weight: 700;
}

/* Grid */
.ov-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

/* Card */
.ov-card {
  background: var(--accent-bg);
  border: 1.5px solid transparent;
  border-radius: 20px;
  padding: 36px 20px 32px;
  text-align: center;
  transition: transform 0.28s cubic-bezier(0.34,1.56,0.64,1),
              box-shadow 0.25s ease,
              border-color 0.25s ease;
  position: relative;
  overflow: hidden;
}
.ov-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: var(--accent);
  border-radius: 20px 20px 0 0;
  opacity: 0;
  transition: opacity 0.25s ease;
}
.ov-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 32px rgba(0,0,0,0.09);
  border-color: var(--accent);
}
.ov-card:hover::before {
  opacity: 1;
}

.ov-card-icon {
  font-size: 2rem;
  margin-bottom: 16px;
  display: block;
  line-height: 1;
}
.ov-card-num {
  font-size: 2.2rem;
  font-weight: 900;
  color: #191b47;
  line-height: 1;
  margin-bottom: 10px;
  font-family: 'Noto Sans Bengali', 'Noto Sans', sans-serif;
}
.ov-card-label {
  font-size: 0.92rem;
  font-weight: 600;
  color: #64748b;
  font-family: 'Noto Sans Bengali', 'Noto Sans', sans-serif;
}

/* Responsive */
@media (max-width: 900px) {
  .ov-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 480px) {
  .ov-grid { grid-template-columns: repeat(2, 1fr); gap: 14px; }
  .ov-card { padding: 28px 16px 24px; }
  .ov-card-num { font-size: 1.7rem; }
  .overview-section { padding: 56px 0 64px; }
}
</style>